import angular from 'angular';
import QuestionManageComponent from './question-manage.component';

const QuestionManage = angular
    .module('control-room.app-settings.components.question-manage', [])
    .component('crQuestionManage', QuestionManageComponent);

export default QuestionManage;
